exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#natp-footer h4{color:#414042;font-size:18px;text-transform:capitalize}#natp-footer b,#natp-footer h4{font-family:Roboto,sans-serif;font-weight:500}#natp-footer b{font-size:15px;margin-bottom:-8px}#natp-footer a{color:#414042!important}#natp-footer a:hover{color:#23527c!important}footer{background:none!important;margin-bottom:-15px;margin-top:20px!important}#natp-footer{background-color:#d0cfd0}.facebook-footer,.insta-footer,.linkedin-footer,.twitter-footer{background-image:url(\"https://www.natptax.com/Style%20Library/_natptax/social-media-icons-website-footer-all-130.png\");display:inline-block;height:30px;margin-right:5px;overflow:hidden;width:30px}.facebook-footer{background-position-x:-33px}.linkedin-footer{background-position-x:63px}.insta-footer{background-position-x:29px}.facebook-footer:hover,.insta-footer:hover,.linkedin-footer:hover,.twitter-footer:hover{background-position-y:29px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/scripts/components/footer/footer.css
// module id = 41
// module chunks = 0